import React, { useState, useEffect } from 'react';
import Button from './Button';

interface PWAUpdateToastProps {
  onUpdate: () => void;
  onDismiss: () => void;
}

const PWAUpdateToast: React.FC<PWAUpdateToastProps> = ({
  onUpdate,
  onDismiss,
}) => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    // Show the toast after a short delay
    const timer = setTimeout(() => {
      setIsVisible(true);
    }, 1000);

    return () => clearTimeout(timer);
  }, []);

  const handleUpdate = () => {
    onUpdate();
    setIsVisible(false);
  };

  const handleDismiss = () => {
    onDismiss();
    setIsVisible(false);
  };

  if (!isVisible) {
    return null;
  }

  return (
    <div className='fixed top-4 right-4 z-50 max-w-sm'>
      <div className='bg-white dark:bg-gray-800 border border-gray-200 dark:border-gray-700 rounded-lg shadow-lg p-4'>
        <div className='flex items-start space-x-3'>
          <div className='flex-shrink-0'>
            <span className='text-2xl'>🔄</span>
          </div>
          <div className='flex-1 min-w-0'>
            <p className='text-sm font-medium text-gray-900 dark:text-white'>
              Update Available
            </p>
            <p className='text-sm text-gray-500 dark:text-gray-400 mt-1'>
              A new version of Riddl is available. Update now for the latest
              features!
            </p>
          </div>
        </div>
        <div className='flex space-x-2 mt-3'>
          <Button
            variant='primary'
            size='sm'
            onClick={handleUpdate}
            className='flex-1'
          >
            Update Now
          </Button>
          <Button
            variant='secondary'
            size='sm'
            onClick={handleDismiss}
            className='flex-1'
          >
            Later
          </Button>
        </div>
      </div>
    </div>
  );
};

export default PWAUpdateToast;
